import { render } from "./NotificationCardLoader.vue?vue&type=template&id=bc1e8998"
import script from "./NotificationCardLoader.vue?vue&type=script&lang=js"
export * from "./NotificationCardLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__